module.exports = __webpack_public_path__ + "static/media/announcement.a3438feb.svg";